// extracted by mini-css-extract-plugin
export var baseButton = "_up-0";
export var controlsArrowKeys = "_up-1";
export var controlsResetButton = "_up-2";
export var lightGameButton = "_up-4 _up-0";
export var playAgainButton = "_up-5 _up-0";
export var startGameButton = "_up-3 _up-0";